export default "__VITE_ASSET__386OaEZj__"